import React, { useEffect, useState } from "react";
import "../styles/DashRepSelect.css";

function DashRepSelect() {
  const [representativesList, setRepresentativesList] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [selectedRepresentative, setSelectedRepresentative] = useState(null);
  const [selectedProductId, setSelectedProductId] = useState("");
  const [targetValue, setTargetValue] = useState("");

  useEffect(() => {
    getRepresentativesList();
    getProductsList();
  }, []);

  async function getProductsList() {
    try {
      const response = await fetch(
        "https://cairomed-backend.vercel.app/api/products/getProduct"
      );
      if (!response.ok) {
        throw new Error("Failed to fetch Products data");
      }
      const data = await response.json();
      setProductsList(data);
    } catch (error) {
      console.error("Error fetching Products:", error);
    }
  }

  async function getRepresentativesList() {
    try {
      const response = await fetch(
        "https://cairomed-backend.vercel.app/api/representatives/getRepresentatives"
      );
      if (!response.ok) {
        throw new Error("Failed to fetch representatives data");
      }
      const data = await response.json();
      setRepresentativesList(data);
    } catch (error) {
      console.error("Error fetching representatives:", error);
    }
  }

  async function fetchSelectedRepresentative(repId) {
    try {
      const response = await fetch(
        `https://cairomed-backend.vercel.app/api/representatives/getRepresentative/${repId}`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch representative data");
      }
      const data = await response.json();
      setSelectedRepresentative(data); // Store the full representative object, including updated targets
    } catch (error) {
      console.error("Error fetching representative:", error);
    }
  }

  const handleRepresentativeClick = (representative) => {
    fetchSelectedRepresentative(representative._id); // Fetch updated rep details when selected
  };

  const handleBackButtonClick = () => {
    setSelectedRepresentative(null);
  };

  const handleProductChange = (event) => {
    setSelectedProductId(event.target.value);
  };

  const handleTargetChange = (event) => {
    setTargetValue(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await fetch("https://cairomed-backend.vercel.app/api/targets", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          product: selectedProductId,
          target: targetValue,
          representative: selectedRepresentative._id,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to save target");
      }

      // Fetch updated representative data after adding a new target
      fetchSelectedRepresentative(selectedRepresentative._id);

      // Reset form
      setSelectedProductId("");
      setTargetValue("");
    } catch (error) {
      console.error("Error saving target:", error);
    }
  };


  return (
    <section id="DashRepSelect">
      {!selectedRepresentative && (
        <div className="representative-container container mt-7">
          {representativesList.map((representative) => {
            return (
              <div
                className="representative-card mb-3"
                key={representative._id}
                onClick={() => handleRepresentativeClick(representative)}
              >
                <picture>
                  <img
                    src={representative.Image || "fallback-image.jpg"}
                    className="card-img-top cardImg"
                    alt={representative.NameEN || "Representative"}
                  />
                </picture>
                <div className="representative-card-content">
                  <div>
                    <i className="fa-regular fa-address-card cardText"></i>
                    <p>
                      <span>Name:</span>
                      {representative.NameEN || "N/A"}
                    </p>
                  </div>
                  <div>
                    <i className="fa-regular fa-address-card cardText"></i>
                    <p>
                      <span>Phone Number:</span>
                      {representative.PhoneNumber || "N/A"}
                    </p>
                  </div>
                  <div>
                    <i className="fa-regular fa-address-card cardText"></i>
                    <p>
                      <span>Region:</span>
                      {representative.AreaEN || "N/A"}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {selectedRepresentative && (
        <div className="selected-representative-profile">
          <div className="repProfile-header">
          <div className="repProfile-pic-box">
            <picture>
              <img
                src={selectedRepresentative.Image || "fallback-image.jpg"}
                className="card-img-top cardImg"
                alt={selectedRepresentative.NameEN || "Representative"}
              />
            </picture>
            {selectedRepresentative.NameEN || "N/A"}
          </div>
          <div className="profile-small-box-container">
            <div className="profile-small-box">
              <span> ID</span>
              {selectedRepresentative._id || "N/A"}
            </div>
            <div className="profile-small-box">
              <span> Email</span>
              {selectedRepresentative.email || "N/A"}
            </div>
            <div className="profile-small-box">
              <span> Phone Number</span>
              {selectedRepresentative.PhoneNumber || "N/A"}
            </div>
            <div className="profile-small-box">
              <span> Region</span>
              {selectedRepresentative.AreaEN || "N/A"}
            </div>
          </div>
          </div>
          <div>
            <div>
              <button
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
              >
                <span>add target</span>
              </button>
            </div>
            {selectedRepresentative.targets.map((target) => (
              <div>
                <h4>{target.product.ProductNameEN}</h4> 
              <div key={target._id} className="progress mt-2">

                <div
                  className="progress-bar progress-bar-striped progress-bar-animated"
                  role="progressbar"
                  aria-valuenow={target.progress}
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{ width: `${target.progress}%` }}
                >
                  {target.progress}%
                </div>
                
              </div>
              <div className="d-flex justify-content-between mt-1 mb-3">
                <div className="d-flex flex-column">  
                  <span>Achived</span>
                  <span>{target.achived}</span>
                </div>
                <div className="d-flex flex-column">
                <span>Target</span>
                <span>{target.target}</span>
                </div>
              </div>
              </div>
            ))}
          </div>
          <button onClick={handleBackButtonClick} className="back-button btn-warning btn ">
            Back
          </button>
        </div>
      )}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Modal title
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <label htmlFor="productSelect">Select product</label>
                <select
                  id="productSelect"
                  value={selectedProductId}
                  onChange={handleProductChange}
                >
                  <option value="">Select a product</option>
                  {productsList.map((product) => (
                    <option key={product._id} value={product._id}>
                      {product.ProductNameEN}
                    </option>
                  ))}
                </select>
                <label htmlFor="targetInput">Target</label>
                <input
                  type="number"
                  id="targetInput"
                  value={targetValue}
                  onChange={handleTargetChange}
                />
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Save changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DashRepSelect;